<template>
  <div class="w-full">
    <pbc-toggle-button v-model='selections[transformsAndSource.c.id]' v-for='transformsAndSource in transformsAndSources' :key='transformsAndSource.c.id' class="w-20 h-20">
      <toy-from-component class="p-2 w-20 h-20" :transforms-and-source='transformsAndSource'  />
    </pbc-toggle-button>
  </div>
</template>
<script>
import ToyFromComponent from '@edit/molecules/ToyFromComponent.vue';
export default {
  props: {
    transformsAndSources: {
      type: Array,
      required: true
    },
    selections: {
      type: Object,
      default() {
        return {
        }
      }
    },
    initializeEmpty: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ToyFromComponent
  },
  data() {
    if (this.initializeEmpty) {
      this.transformsAndSources.forEach( (tas) => {
        this.$set(this.selections, tas.c.id, false);
      });
    }
    return {
    }
  }
}
</script>
